module.exports = __webpack_public_path__ + "img/logo-sm.2b27b82f.png";